const COACHUP_REGEXP = /^coachup\./i;

export const IS_COACHUP: boolean = COACHUP_REGEXP.test(window.location.hostname);
